import { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Menu, Coins } from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CoinIcon } from '../ui/CoinIcon';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CoinBadge = ({ balance, size = 'md', onClick }) => {
  const sizes = {
    sm: 'px-2.5 py-1 text-xs gap-1.5',
    md: 'px-3 py-1.5 text-sm gap-2',
  };
  const low = balance !== null && balance <= 8;
  return (
    <button
      onClick={onClick}
      className={`flex items-center ${sizes[size]} rounded-xl font-bold transition-all hover:scale-105 active:scale-95 ${
        low
          ? 'bg-red-50 border border-red-200 text-red-600 hover:bg-red-100'
          : 'bg-yellow-50 border border-yellow-200 text-yellow-700 hover:bg-yellow-100'
      }`}
      title="Coin Guru — klik untuk topup"
    >
      <CoinIcon size={18} />
      <span>
        {balance === null ? '...' : balance}
        <span className="font-normal opacity-70 ml-1">koin</span>
      </span>
      {low && <span className="text-[10px] bg-red-100 text-red-500 px-1.5 py-0.5 rounded-full font-semibold">Menipis!</span>}
    </button>
  );
};

export const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed]   = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coinBalance, setCoinBalance] = useState(null);
  const navigate = useNavigate();

  const fetchCoinBalance = () => {
    axios.get(`${API}/coins/balance`, { withCredentials: true })
      .then(r => setCoinBalance(r.data.coin_balance))
      .catch(() => {});
  };

  useEffect(() => {
    fetchCoinBalance();
    window.addEventListener('coinBalanceUpdated', fetchCoinBalance);
    return () => window.removeEventListener('coinBalanceUpdated', fetchCoinBalance);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">

      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">

        {/* Topbar */}
        <header className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-b border-slate-100 flex-shrink-0">
          {/* Left: mobile menu + logo */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileOpen(true)}
              className="lg:hidden w-9 h-9 rounded-lg border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-50 transition-colors"
            >
              <Menu size={20} />
            </button>
            <div className="lg:hidden flex items-center gap-2">
              <img src="/logo.png" alt="RencanaGuru" className="h-7 w-7 object-contain" />
              <span className="font-bold text-blue-900 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                RencanaGuru<span className="text-yellow-500">.com</span>
              </span>
            </div>
          </div>

        </header>

        {/* Scrollable content */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};
